const toTitleCase = (str: string) => {
    return str.replace( /\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

const pickRandomString = (arr : string[]) => {
    var index = Math.floor(Math.random() * arr.length); 
    return arr[index];
}

const getOrdinalSuffix = (n: number) => {
    return["st","nd","rd"][((n+90)%100-10)%10-1]||"th"
}


const isMobileOS = () => {
    return (/Android|aarch64|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent))
}

export { 
    toTitleCase,
    pickRandomString,
    getOrdinalSuffix,
    isMobileOS
}